import { useState, useEffect } from 'react';
import axios from 'axios';

export const useLearnerInvoices = (admNo) => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!admNo) {
      setInvoices([]);
      return;
    }
    const fetch = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/finance/invoices/unpaid/${admNo}`,
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );
        setInvoices(data);
      } catch (e) {
        console.error(e);
        setInvoices([]);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [admNo]);

  return { invoices, loading };
};